import { Component } from '@angular/core';

@Component({
  selector: 'app-login-failed',
  imports: [],
  templateUrl: './login-failed.component.html',
  styleUrl: './login-failed.component.css'
})
export class LoginFailedComponent {

}
